module.exports = __webpack_public_path__ + "img/cart-remove-coupon-icon.5ccac4ca.svg";